import { cn } from '../lib/cn';

const styles: Record<string, string> = {
  LIVE:                 'bg-green-500/10 text-green-400',
  CONFIRMED:            'bg-green-500/10 text-green-400',
  CLAIMED:              'bg-green-500/10 text-green-400',
  PENDING:              'bg-amber-500/10 text-amber-300',
  PENDING_CLAIM:        'bg-amber-500/10 text-amber-300',
  IN_PROGRESS:          'bg-blue-500/10 text-blue-400',
  AWAITING_CONFIRMATION:'bg-blue-500/10 text-blue-400',
  COMPLETED:            'bg-red-500/10 text-red-400',
  DISPUTED:             'bg-red-500/10 text-red-400',
  CLOSED:               'bg-gray-500/10 text-gray-400',
  ENDED:                'bg-gray-500/10 text-gray-400',
  GHOST:                'bg-gray-500/10 text-gray-500',
  LEADER:               'bg-violet-500/10 text-violet-400',
  MEMBER:               'bg-gray-500/10 text-gray-400',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        styles[status] ?? 'bg-gray-500/10 text-gray-400'
      )}
    >
      {status.replace(/_/g, ' ')}
    </span>
  );
}
